import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import { Forgot} from '../pages/auth/Forgot'
import Login from '../pages/auth/Login'
import ResetPassword from '../pages/auth/ResetPassword'
import RegisterLanding from '../pages/auth/RegisterLanding'
import RegisterCandidate from '../pages/auth/RegisterCandidate'
import RegisterSchool from '../pages/auth/RegisterSchool'
import Activation from '../pages/auth/Activation'

export default function AuthRouter () {
    return (
        <Routes>
            <Route path="/" element={<Login />}/>
            <Route path="/login" element={<Login />}/>
            <Route path="/forgotpassword" element={<Forgot />}/>
            <Route path="/resetpassword/:id/:tokenresetpassword" element={<ResetPassword />}/>
            <Route path="/registerlanding" element={<RegisterLanding />}/>
            <Route path="/registercandidate" element={<RegisterCandidate />}/>
            <Route path="/registerschool" element={<RegisterSchool />}/>
            <Route path="/activation/:idUser" element={<Activation />}/>
            <Route path="*" element={<NotFoundPage />}/>
        </Routes>
    )
}